module.exports = __webpack_public_path__ + "ab55075.woff2";